export default __webpack_public_path__ + "static/media/anti-slip_gray.a7d8e802.webp";